/** Single place the copyright line is defined; every surface renders this string. */
export const COPYRIGHT = "© 2026 misebox";
